import React from 'react';
import { Link } from 'react-router-dom';

// Import images (update paths based on your actual images)
import provisionStores from '../../assets/images/provision-stores.jpg';
import deckStores from '../../assets/images/Deck and safety store.jpg';
import cabinStores from '../../assets/images/Cabin store.jpg';

const shipStoresProducts = [
  {
    id: 1,
    title: 'Provision Stores',
    description: 'Essential daily goods and supplies for maritime needs. From quality food provisions and beverages to essential consumables, we ensure your crew stays comfortable and your vessel operations run smoothly throughout the voyage.',
    image: provisionStores,
  },
  {
    id: 2,
    title: 'Deck & Engine Stores',
    description: 'Complete range of durable deck equipment and accessories. We supply premium mooring ropes, deck fittings, maintenance tools, and essential gear to support safe and efficient deck operations on every vessel.',
    image: deckStores,
  },
  {
    id: 3,
    title: 'Cabin Stores',
    description: 'Reliable cabin supplies and onboard equipment for marine operations. Our inventory includes storage units, safety accessories, and everyday items designed to support comfort, organization, and performance at sea.',
    image: cabinStores,
  },
];

const ShipStoresSupply = () => {
  return (
    <section id="chandlery" className="section-y bg-lightGray scroll-mt-28">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <p className="section-kicker">Ship chandlery</p>
          <h2 className="section-title">Ship Stores Supply</h2>
          <p className="section-subtitle">
            Comprehensive ship supply solutions for efficient maritime operations
          </p>
        </div>

        {/* Ship Stores Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {shipStoresProducts.map((product) => (
            <div
              key={product.id}
              className="card-surface overflow-hidden group flex flex-col"
            >
              {/* Image */}
              <div className="h-56 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              {/* Content */}
              <div className="p-6 lg:p-7 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-navy mb-3 tracking-tight">
                  {product.title}
                </h3>
                <p className="text-darkGray/75 leading-relaxed text-sm flex-grow">
                  {product.description}
                </p>
                
                <Link
                  to="/contact"
                  className="mt-5 text-teal font-semibold hover:text-navy transition-colors duration-200 inline-flex items-center gap-1.5 w-fit"
                >
                  Contact Us
                  <span className="group-hover:translate-x-1 transition-transform" aria-hidden>→</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShipStoresSupply;